import React from 'react';
import { cloneDeep } from 'lodash';
import { assign } from 'xstate';
import { IntlShape } from 'react-intl';

import { BaseComponent } from '../Component';
import { MachineContext } from '../../MachineContext';
import { translateWithFallback } from '../../util';

import { EmotionEnum } from './EmotionEnum';
import { EmotionInputItem } from './EmotionInput';
import styles from './Emotion.module.css';

export interface EmotionIconComponent extends BaseComponent {
  type: 'emotionIcon';
  props: EmotionIconProps;
}
export interface EmotionIconProps {
  emotion: EmotionEnum;
  active?: boolean;
}
export const EmotionIcon: React.FC<EmotionIconProps> = ({
  emotion,
  active = false,
}) => {
  return (
    <div
      className={
        styles[emotion] +
        ' ' +
        styles['icon'] +
        ' ' +
        styles[`active-${active}`]
      }
    />
  );
};

/** renderEmotionIcon renders a single emotion icon based on EmotionEnum type  */
export const renderEmotionIconAction = assign(
  (context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    const getValueFrom = actionMetadata.action.payload.getValueFrom;
    const emotion = context.userData[getValueFrom];

    newContext.widgetData.push({
      type: 'emotionIcon',
      temporary: actionMetadata.action.temporary ?? false,
      props: { emotion: emotion },
    });
    return newContext;
  }
);

/** renderEmotionIcon renders a list of emotion icons based on EmotionEnum[] types
 * is used for echo, only
 */
export const renderEmotionIconsAction = (intl: IntlShape) => {
  return assign((context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    const getValueFrom = actionMetadata.action.payload.getValueFrom;
    const emotions = context.userData[getValueFrom];

    if (emotions && Array.isArray(emotions)) {
      emotions.forEach((emotion: EmotionInputItem) => {
        newContext.widgetData.push({
          type: 'emotionIcon',
          temporary: actionMetadata.action.temporary ?? false,
          props: { emotion: emotion.icon },
        });
        newContext.widgetData.push({
          type: 'coacheeMessage',
          temporary: actionMetadata.action.temporary ?? false,
          props: {
            message: emotion.type.toLowerCase().includes('owninput')
              ? emotion.value
              : translateWithFallback(intl, emotion.value),
          },
        });
      });
    }
    return newContext;
  });
};
